import { performSignUp } from "../api/dataFactory";
import {
  signUpNameRule,
  signUpUsernameRule,
  signUpPasswordRule,
  agreeTermAndConditionRule
} from "..//utils/formRulesCheck";

const authPortalSignUpMixins = {
  metaInfo: {
    title: "1byone health Sign Up"
  },
  data() {
    return {
      signUpNameRule,
      signUpUsernameRule,
      signUpPasswordRule,
      agreeTermAndConditionRule,
      isValid: true,
      name: "",
      username: "",
      password: "",
      performSignUpPending: false,
      hasError: false,
      registerSucceed: false,
      signupErrorMessage: ""
    };
  },
  methods: {
    async performSignup() {
      this.hasError = false;
      this.signupErrorMessage = "";
      if (this.$refs.signUpForm.validate()) {
        this.performSignUpPending = true;
        let signUpFormData = new FormData();
        signUpFormData.append("username", this.username);
        signUpFormData.append("password", this.password);
        signUpFormData.append("name", this.name);

        let signUpResult = await performSignUp(signUpFormData);
        if (signUpResult == undefined) {
          this.hasError = true;
          this.signupErrorMessage =
            "encounter unexpected error, please retry in a few minutes";
        } else if (signUpResult.resultCode == "100") {
          this.registerSucceed = true;
        } else if (signUpResult.resultCode == "201") {
          this.hasError = true;
          this.signupErrorMessage =
            "this email is already associated with an account";
        }
        if (this.hasError) {
          this.$refs.signUpForm.reset();
        }
        this.performSignUpPending = false;
      }
    }
  }
};

export default authPortalSignUpMixins;
